// @flow

import React from "react";
import SearchContext from "../searchContext";
import ResultItemContainer from "../results/ResultItemContainer";

const ResultsListContainer = () => {
  return (
    <SearchContext.Consumer>
      {({ translations, results }) => {
        let resultsItem = "";
        if (results.length) {
          resultsItem = results.map((result, index) => (
            <ResultItemContainer
              key={index}
              result={result}
              translations={translations}
            />
          ));
        } else {
          resultsItem = (
            <p className="no-results">
              {translations
                ? translations.no_results_label
                : "No results found for these filters."}
            </p>
          );
        }
        return (
          <div className="locations-wrapper">
            {/*<h2>
              {translations
                ? translations['search_results_label']
                : 'Search results'}
              </h2>*/}
            {resultsItem}
          </div>
        );
      }}
    </SearchContext.Consumer>
  );
};

export default ResultsListContainer;
